import { useState } from 'react';
import { createInquiry } from '../services/api';
import { company } from '../content/companyContent';
import { FaAmbulance, FaClock, FaEnvelope, FaMapMarkerAlt, FaPhoneAlt } from 'react-icons/fa';
import './Contact.css';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await createInquiry(formData);
      setSubmitted(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
      });
    } catch (err) {
      setError('Failed to send message. Please call us directly if this is urgent.');
      console.error('Error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-hero">
        <h1>Contact Us</h1>
        <p>Reach the Rinkal Enterprise & Healthcare Services team.</p>
      </div>

      <div className="contact-container">
        <div className="contact-form-wrapper">
          {submitted ? (
            <div className="success-message">
              <h2>Message Sent Successfully</h2>
              <p>Thank you for contacting us. We will get back to you shortly.</p>
              <button onClick={() => setSubmitted(false)} className="btn-primary">
                Send Another Message
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="contact-form">
              <h2>Send Us a Message</h2>

              {error && <div className="error-message">{error}</div>}

              <div className="form-group">
                <label htmlFor="name">Full Name *</label>
                <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required />
                </div>
                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject *</label>
                <input type="text" id="subject" name="subject" value={formData.subject} onChange={handleChange} required />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Tell us what support you need..."
                  rows="6"
                  required
                />
              </div>

              <button type="submit" className="btn-submit" disabled={loading}>
                {loading ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          )}
        </div>

        <div className="contact-info">
          <div className="info-section">
            <h3><FaPhoneAlt /> Phone</h3>
            <p>{company.phone}</p>
          </div>

          <div className="info-section">
            <h3><FaEnvelope /> Website</h3>
            <p>{company.website}</p>
          </div>

          <div className="info-section">
            <h3><FaMapMarkerAlt /> Address</h3>
            <p>{company.address}</p>
          </div>

          <div className="info-section">
            <h3><FaClock /> Hours of Operation</h3>
            <p>Monday - Saturday: 9:00 AM - 6:00 PM<br />Emergency coordination available 24/7</p>
          </div>

          <div className="info-section">
            <h3><FaAmbulance /> Emergency</h3>
            <p>24/7 Ambulance Services<br />{company.phone}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
